import React, { useState, useEffect, useReducer } from "react";
import BookingsHeader from "./BookingsHeader";
import BookingsListItem from "../../components/BookingsListItems/BookingsListItems";
import LoadingOverlay from "react-loading-overlay";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";
const { request, handleErrors } = require("../../services/helpers")
const inputClass =
    "appearance-none block w-full font-display border border-gray-400 rounded py-3 px-4 mb-3 leading-tight focus:outline-none bg-white focus:border-gray-500";
const labelClass =
    "block tracking-wide text-black font-display text-sm leading-5 font-medium mb-2";

const SET_FORM_LOADING = "SET_FORM_LOADING";

// const GET_MEMBERSHIPS_SUCCESS = "GET_MEMBERSHIPS_SUCCESS";
// const GET_MEMBERSHIPS_FAILURE = "GET_MEMBERSHIPS_FAILURE";
// const SELECT_MEMBERSHIP_SUCCESS = "SELECT_MEMBERSHIP_SUCCESS";
const GET_ROOMS_SUCCESS = "GET_ROOMS_SUCCESS";
const GET_ROOMS_FAILURE = "GET_ROOMS_FAILURE";
const SELECT_ROOMS_SUCCESS = "SELECT_ROOMS_SUCCESS";
const SELECT_ROOMS_FAILURE = "SELECT_ROOMS_FAILURE";


const initialState = {
    loading: false,
    error: "",
    conferenceRooms: [],
    roomSelected: null
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_FORM_LOADING:
            return {
                ...state,
                loading: action.payload === false ? action.payload : true,
                error: "",
            };

        case GET_ROOMS_SUCCESS: {
            return {
                ...state,
                loading: false,
                conferenceRooms: action.payload,
            };
        }

        case GET_ROOMS_FAILURE: {
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        }

        case SELECT_ROOMS_SUCCESS: {
            return {
                ...state,
                loading: false,
                roomSelected: action.payload.name,
            };
        }

        case SELECT_ROOMS_FAILURE: {
            return {
                ...state,
                error: action.payload,
                loading: false,
                roomSelected: null,
            };
        }

        default:
            return state;
    }
};


const RoomwiseBookings = (props) => {

    const [date, setDate] = useState();
    const [location, setLocation] = useState("");
    const [bookingsArray, setBookingsArray] = useState([]);

    const [inputValue, setInputValue] = React.useState('');
    const [loadData, setLoadData] = useState(false);

    const [data, setData] = useState([]);
    const [creditsUsed, setCreditsUsed] = useState();

    const [state, dispatch] = useReducer(reducer, initialState);
    const { loading, error, conferenceRooms, roomSelected } = state;

    // GET_ALL_ROOMS
    useEffect(() => {
        let active = true;
        (async () => {
            dispatch({ type: SET_FORM_LOADING });
            try {
                // throw new Error("help");
                const res = await request.get(`/bookings/all-rooms/?location=${location}`);
                // if (!Array.isArray(res.data))
                //     throw new Error("Something went wrong. Please reload the page.");
                if (active) {
                    dispatch({
                        type: GET_ROOMS_SUCCESS,
                        payload: res.data,
                    });
                }
            } catch (e) {
                if (active) {
                    dispatch({
                        type: GET_ROOMS_FAILURE,
                        payload: handleErrors(e),
                    });
                }
            }
        })();
        return () => {
            active = false;
        };
    }, [location]);

    const handleRoomSelect = async (event, value) => {
        dispatch({ type: SELECT_ROOMS_SUCCESS, payload: value });
    };

    const locations = [
        { name: '2gethr@ORR', value: '2gethr@ORR' },
        { name: '2gethr@HSR', value: '2gethr@HSR' },
        // { name: 'All', value: 'all' },
    ]

    const getData = async (queryData) => {
        // const axios = require('axios');

        const {
            dateData,
            locationData,
            roomSelectedData
        } = queryData;

        let formattedStartDate = moment(dateData).startOf('day').subtract(6, 'hours');
        let formattedEndDate = moment(dateData).startOf('date');

        // let expDate = moment(formattedStartDate).startOf('date')
        // let formattedStartDate = moment(dateData, 'Do MMM YYYY').startOf('date')._i;
        // console.log(expDate, 'date');

        const { data } = await request.get(
            `bookings/all-bookings-room?location=${locationData}&room=${roomSelectedData}&startDate=${formattedStartDate}&endDate=${formattedEndDate}`
        );

        if (Array.isArray(data)) {
            setBookingsArray([...data]);
            setLoadData(true);
        }
        else {
            // Error, response not an array!
        }


    }

    useEffect(() => {
        if (date && location && roomSelected) {
            getData({ dateData: date, locationData: location, roomSelectedData: roomSelected });
        }
    }, [date, location, roomSelected]);

    const renderbookings = () => {
        return (
            loadData ? (
                !(bookingsArray?.length) ?
                    <div>
                        <h3 className="font-normal text-lg">No Bookings Found!</h3>
                    </div> :
                    bookingsArray.map((item) => {
                        return (
                            <div key={item._id} className="bg-gray-100 py-8 md:px-0 px-4  md:w-3/4 w-full">
                                <div className="flex flex-col pl-10 border-b-2 border-gray-300 py-2 bg-gray-200">
                                    <h2 className="font-bold text-lg">Room: {item.roomId.name} </h2>
                                    <h2 className="font-bold text-lg">Date: {moment(item.dateToBook).format("MMMM Do YYYY")} </h2>
                                    <h3 className="font-normal text-lg">Cost: {item.roomId.conference__cost_in_credits} Credits/Hour</h3>
                                    {/* <h3 className="font-normal text-lg">{item.reservations[0].owner.id.name} || {moment(item.dateToBook).format("MMMM Do YYYY")} || {item.reservations[0].owner.id.email} Credits/Hour</h3> */}
                                </div>
                                <div className=" flex flex-col border-b-3 border-gray-500 w-full">
                                    {reservationMapper(item.reservations)}
                                </div>
                                {/* <div className="pt-4">
                                    < BookingsListItem
                                        bookings={item}
                                    />
                                </div> */}
                            </div>
                        );
                    })
            ) : (
                <span className="text-base leading-5 text-gray-500">
                    Not loaded
                </span>
            )
        );
    }

    const reservationMapper = (reservations) => {
        return (
            reservations.map((item, i) => {
                return (
                    <div className="flex flex-row border-b-2 border-gray-500 py-2 pl-4 w-full">
                        <div className="flex flex-none w-20 items-center justify-center">
                            <h3 className="font-normal text-md">{i + 1}.</h3>
                        </div>
                        <div className="flex flex-none items-center justify-center w-40">
                            <img className="h-20 w-20 rounded-full" src={item?.owner?.id?.userProfilePic.small} alt="User" />
                        </div>
                        <div className="flex-1 flex-col pl-10">
                            <h2 className="font-bold text-lg">Time: {item?.slot?.number - 1}:00 - {item?.slot?.number}:00</h2>
                            <h3 className="font-normal text-lg">Name: {item?.owner?.id?.name}</h3>
                            {item?.owner?.id?.email ?
                                <h3 className="font-normal text-lg">Email: {item?.owner?.id?.email}</h3> :
                                <h3 className="font-normal text-lg">Phone: {item?.owner?.id?.phone_number}</h3>
                            }
                        </div>
                    </div>
                );
            })
        );
    }


    return (
        <LoadingOverlay
        >
            <div className="py-8 lg:px-16 px-8 flex flex-col flex-1 bg-formBackground mb-16">
                <BookingsHeader />
                <div className="mt-12">
                    <span className="text-base leading-5 text-gray-500">
                        Show Bookings For
                    </span>
                    {/* Filter Inputs */}
                    <div className="mt-3">
                        <div className="md:flex md:space-x-8">

                            <div className="md:w-1/2 w-full mb-6">
                                <label
                                    className="block truncate tracking-wide text-black font-display text-sm leading-5 font-medium mb-2"
                                    htmlFor="center-location"
                                >
                                    Center Location
                                </label>
                                <Autocomplete
                                    options={locations || []}
                                    getOptionSelected={(option, value) => option.name === value.name}
                                    getOptionLabel={(option) => option.name}
                                    onChange={(_, data) => {
                                        setLocation(data.value);
                                    }}
                                    renderInput={(props) => (
                                        <div
                                            className="flex items-center"
                                            ref={props.InputProps.ref}
                                        >
                                            <div className="w-full">
                                                <input
                                                    style={{
                                                        width: "100%",
                                                        padding: "10px",
                                                        borderRadius: "4px",
                                                        borderColor: "#cbd5e0",
                                                        border: "1px solid #cbd5e0",
                                                        outline: "none",
                                                    }}
                                                    defaultValue={location}
                                                    type="text"
                                                    placeholder="Select a Center"
                                                    {...props.inputProps} />
                                            </div>
                                        </div>
                                    )}
                                />
                            </div>

                            <div className="md:w-1/2 w-full mb-6">
                                <label
                                    className="block truncate tracking-wide text-black font-display text-sm leading-5 font-medium mb-2"
                                    htmlFor="center-location"
                                >
                                    Select a Conference Room
                                </label>
                                <Autocomplete
                                    options={conferenceRooms || []}
                                    getOptionSelected={(option, value) => option.name === value.name}
                                    getOptionLabel={(option) =>
                                        option.name
                                    }
                                    name="RoomSearch"
                                    onChange={
                                        handleRoomSelect
                                    }
                                    renderInput={(params) => (
                                        <Input
                                            params={params}
                                            textFieldProps={{
                                                placeholder: "Select a Conference Room",
                                            }}
                                            type="text"
                                            {...props.inputProps}
                                        />
                                    )}
                                />
                            </div>


                            <div className="md:w-1/2 w-full mb-6">
                                <label className={labelClass} htmlFor="inspect-date">
                                    Date
                                </label>

                                <input
                                    className={inputClass}
                                    id="inspect-date"
                                    placeholder="Date to inspect"
                                    type="date"
                                    name="inspect_date"
                                    onChange={(data) => {
                                        setDate(data.target.value);
                                    }}
                                />
                            </div>

                        </div>
                        <div>
                            {renderbookings()}
                        </div>
                    </div>

                </div>
            </div>
        </LoadingOverlay >

    );
}

export default RoomwiseBookings;

const Input = ({ params, textFieldProps }) => (
    <div className="flex items-center" ref={params.InputProps.ref}>
        <div className="w-full">
            <input
                style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "4px",
                    borderColor: "#cbd5e0",
                    border: "1px solid #cbd5e0",
                    outline: "none",
                }}
                type="text"
                {...params.inputProps}
                {...textFieldProps}
            />
        </div>
    </div>
);